import { Button } from "react-bootstrap";
import { FaRegQuestionCircle } from "react-icons/fa";
import { setAssistantOpen } from "./useAssistant";

export function AssistantButton() {
  return (
    <Button
      className="assistant-btn"
      variant="none"
      onClick={() => setAssistantOpen(true)}
      // TODO(i18n): new key needed
      aria-label={"open" /*t("assistant.open")*/}
    >
      <FaRegQuestionCircle />
    </Button>
  );
}
